import React, { useEffect, useState } from 'react';
import { Form, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import './CommunicationPrefEdit.scss';
import DrawerFormContainer from 'components/drawerFormContainer/DrawerFormContainer';
import TopAlignCheckbox from 'components/topAlignCheckbox/TopAlignCheckbox';
import { LoyaltyAccount, MemberProfile } from 'types/dto/profile';
import { UpdateProfileDTO } from 'types/dto/order';
import { fetchProfile, updateProfile } from 'services/profileService';
// import { useSession } from 'context/SessionContext';

interface CommunicationPrefEditProps {
  visible: boolean;
  onClose: () => void;
  onSave?: () => void;
  initialPreference?: string;
}

export interface CommunicationPrefEditFormData {
  receiveUpdates: number;
}

const CommunicationPrefEdit: React.FC<CommunicationPrefEditProps> = ({
  visible,
  onClose,
  onSave,
  initialPreference = '0',
}) => {
  const { t } = useTranslation('profile');
  const { t: tCommon } = useTranslation('common');
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const {session} = useSession();

  const handleSave = async () => {
    try {

      const { receiveUpdates } = await form.validateFields();

      setIsSubmitting(true);

     try {
        //step1.fetch profile first to avoid concurrent modification
        // const sessionInfo: SessionInfo = {
        //   sessionID: session?._tk || '',
        //   juicyAppUniqueId: session?._id || '',
        //   customerName: session?._n1 || '',
        //   customerNameZh: session?._n2 || '',
        //   preflang: session?._lg || '',
        //   lastPickUpMethodCode: session?._pu || '',
        //   needTnC: session?._tc || false,
        //   isPasswordCreated: session?._vp || false,
        //   isEmailVerified: session?._ve || false,
        //   parameterCount: 0,
        //   status: session?._st || 'new',
        // };
         const profileData: MemberProfile = await fetchProfile('/profile');

        const updatedLoyaltyAccount: LoyaltyAccount = {
          ...profileData.loyalty_account,
          consent_status: receiveUpdates ? '1' : '0',
        };

        const dto: UpdateProfileDTO = {
          juicyAppUniqueId: profileData?.loyalty_account.unique_id ?? '',
          loyaltyAccount: updatedLoyaltyAccount,
        };

        //step2.update profile
        await updateProfile('/profile', dto);

        onSave?.();
      } catch (error) {
        notification.error({
          message: tCommon('error.updateCommPrefFailed'),
          description: (error as Error).message,
          duration: 1.5,
        });
      }
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ receiveUpdates: initialPreference === '1', });
    }
  }, [form, initialPreference, visible]);

  return (
    <DrawerFormContainer
      title={t('communicationPref.title')}
      visible={visible}
      onClose={() => {
        form.resetFields();
        onClose();
      }}
      onSave={handleSave}
      isSubmitting={isSubmitting}
    >
      <Form
        form={form}
        layout="vertical"
  //      initialValues={{ receiveUpdates: initialPreference === '1' }}
        className="communication-pref-edit-form"
      >
        <Form.Item name="receiveUpdates" valuePropName="checked">
          <TopAlignCheckbox>
            {tCommon('label.receiveUpdatesText')}
          </TopAlignCheckbox>
        </Form.Item>
      </Form>
    </DrawerFormContainer>
  );
};

export default CommunicationPrefEdit;
